import React from "react";
import {Route} from "@/routing/Router";
import JobOpeningsHeading from "@widgets/jobOpenings/heading/JobOpeningsHeading";
import JobOpeningsTable from "@widgets/jobOpenings/table/JobOpeningsTable";

type Props = {
    route: Route,
};

const JobOpeningsOverview = ({route}: Props) => {
    return (
        <>
            <JobOpeningsHeading route={route}/>

            <div className={"mt-6 md:mt-12"}>
                <JobOpeningsTable/>
            </div>
        </>
    );
};

export default JobOpeningsOverview;